import type { CatalogFormContext } from "@school-sales-ai/shared";
import { Input } from "@/components/ui/input";
import { CatalogFields } from "@/components/CatalogFields";
import type { CatalogFieldsValues } from "@/components/CatalogFields";

type LeadFormValues = {
  name: string;
  phone: string;
  email: string;
};

type LeadFormErrors = {
  name?: string;
  phone?: string;
  email?: string;
};

type Props = {
  values: LeadFormValues;
  errors: LeadFormErrors;
  onChange: (field: keyof LeadFormValues, value: string) => void;
  disabled?: boolean;
  catalogContext?: CatalogFormContext;
  /** Passed through to CatalogFields — false in the edit modal. */
  showProduct?: boolean;
  catalogValues?: CatalogFieldsValues;
  onCatalogChange?: (values: CatalogFieldsValues) => void;
};

export function LeadFormFields({
  values,
  errors,
  onChange,
  disabled = false,
  catalogContext,
  catalogValues,
  showProduct = true,
  onCatalogChange,
}: Props): React.JSX.Element {
  const hasCatalogData =
    catalogContext &&
    (catalogContext.cycles.length > 0 ||
      catalogContext.products.length > 0 ||
      catalogContext.customFields.length > 0);
  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-1.5">
        <label
          htmlFor="lead-name"
          className="text-sm font-medium text-ink-700"
        >
          Nombre completo
        </label>
        <Input
          id="lead-name"
          value={values.name}
          onChange={(e) => onChange("name", e.target.value)}
          placeholder="Ej. María García"
          disabled={disabled}
        />
        {errors.name && (
          <p className="text-xs text-red-500">{errors.name}</p>
        )}
      </div>

      <div className="flex flex-col gap-1.5">
        <label
          htmlFor="lead-phone"
          className="text-sm font-medium text-ink-700"
        >
          Teléfono
        </label>
        <Input
          id="lead-phone"
          type="tel"
          value={values.phone}
          onChange={(e) => onChange("phone", e.target.value)}
          placeholder="Ej. 4421234567"
          disabled={disabled}
        />
        {errors.phone && (
          <p className="text-xs text-red-500">{errors.phone}</p>
        )}
      </div>

      <div className="flex flex-col gap-1.5">
        <label
          htmlFor="lead-email"
          className="text-sm font-medium text-ink-700"
        >
          Correo electrónico
        </label>
        <Input
          id="lead-email"
          type="email"
          value={values.email}
          onChange={(e) => onChange("email", e.target.value)}
          placeholder="Ej. maria@correo.com"
          disabled={disabled}
        />
        {errors.email && (
          <p className="text-xs text-red-500">{errors.email}</p>
        )}
      </div>

      {hasCatalogData && catalogValues && onCatalogChange && (
        <CatalogFields
          context={catalogContext}
          values={catalogValues}
          onChange={onCatalogChange}
          disabled={disabled}
          showProduct={showProduct}
        />
      )}
    </div>
  );
}
